import LeadrsLogo from 'components/icons/LeadrsLogo';
import NotificationBell from 'components/notifications/NotificationBell';
import { IoMdMenu } from 'react-icons/io';
import { MdSwapHoriz, MdOutlineAccountBalanceWallet } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';

const Navbar = (props: {
    onOpenSidenav: () => void;
    openSideNav: () => void;
    brandText: string;
    secondary?: boolean | string;
}) => {
    const nav = useNavigate();
    const { openSideNav } = props;
    const [linkedUserType] = useState(() => localStorage.getItem('linked-user-type'));
    const [userType] = useState(() => localStorage.getItem('user-type'));
    const [cagnotteBalance, setCagnotteBalance] = useState<number | null>(null);

    useEffect(() => {
        if (userType !== 'seller') return;
        axios
            .get(`${CONFIG.apiUrl}/user/wallet`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
            })
            .then((res) => setCagnotteBalance(res.data.walletBalance || 0))
            .catch(() => {});
    }, [userType]);

    const showCagnotte = userType === 'seller' && cagnotteBalance !== null;

    const handleSwitchAccount = () => {
        const token = localStorage.getItem('token');
        const userType = localStorage.getItem('user-type');
        const userEmail = localStorage.getItem('user-email');
        const linkedToken = localStorage.getItem('linked-token');
        const linkedUserTypeValue = localStorage.getItem('linked-user-type');

        localStorage.setItem('token', linkedToken);
        localStorage.setItem('user-type', linkedUserTypeValue);
        localStorage.setItem('linked-token', token);
        localStorage.setItem('linked-user-type', userType);
        if (userEmail) localStorage.setItem('linked-user-email', userEmail);

        window.location.href = '/dashboard';
    };

    return (
        <>
            {/* Logo — top-left */}
            <div className="fixed left-5 top-4 z-50">
                <div
                    className="hidden hover:cursor-pointer lg:block"
                    onClick={() => nav('/')}
                >
                    <LeadrsLogo size={36} />
                </div>
                {/* Mobile hamburger */}
                <div className="flex items-center justify-center rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none lg:hidden">
                    <button
                        onClick={openSideNav}
                        className="items-center justify-center bg-[transparent] dark:border-white dark:text-white"
                    >
                        <IoMdMenu size={35} color="#1B254B" />
                    </button>
                </div>
            </div>

            {/* Top-right cluster: cagnotte · account switch · notifications */}
            <div className="fixed right-4 top-4 z-50 flex items-center gap-2">
                {showCagnotte && (
                    <button
                        onClick={() => nav('/cagnotte')}
                        title="Ma cagnotte"
                        className="flex items-center gap-1.5 rounded-full bg-white px-3 py-2 text-xs font-semibold text-leadrs-brand shadow-xl shadow-shadow-500 hover:opacity-80 dark:!bg-navy-800 dark:shadow-none"
                    >
                        <MdOutlineAccountBalanceWallet size={16} />
                        {(cagnotteBalance as number).toLocaleString('fr-FR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}{' '}
                        €
                    </button>
                )}

                {linkedUserType && (
                    <button
                        onClick={handleSwitchAccount}
                        title={`Basculer vers mon compte ${linkedUserType === 'seller' ? 'vendeur' : 'acheteur'}`}
                        className="flex items-center gap-1.5 rounded-full bg-white px-3 py-2 text-xs font-semibold text-leadrs-brand shadow-xl shadow-shadow-500 hover:opacity-80 dark:!bg-navy-800 dark:shadow-none"
                    >
                        <MdSwapHoriz size={16} />
                        {linkedUserType === 'seller' ? 'Vendeur' : 'Acheteur'}
                    </button>
                )}

                <NotificationBell />
            </div>
        </>
    );
};

export default Navbar;
